<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-3 p-ml-3 p-mr-3 p-mb-1" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงาน</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')"  headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                <label for="fullname">{{ $t('imp_fullname') }}</label>
                                <InputText
                                    id="fullname"
                                    type="text"
                                    v-model="fullname"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                <label for="level">{{ $t('imp_level') }}</label>
                                <Dropdown
                                    v-model="levelSelected"
                                    :options="levelOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="levelOptions">
                                        <div v-if="levelOptions.value">
                                            <div>{{ levelOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ levelOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="levelOptions">
                                        <div>{{ levelOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>
                        <!-- <div class="p-field p-col-8 p-lg-2 p-mt-2" >
                <label for="organize">{{ $t("imp_organize") }}</label>
                <InputText
                  id="organize"
                  type="text"
                  v-model="selectedOrganize.name"
                  disabled
                />
            
              </div>
              <div class="p-field p-col-4 p-lg-2" style="padding-top: 3.5px ;">
                <div class="p-formgrid p-grid p-jc-start p-mt-5">
                  <Button
                    @click="showOrganize = true"
                    icon="pi pi-ellipsis-h"
                    class="p-button-secondary p-mr-2"
                  />
                  <Button
                    @click="selectedOrganize = {}"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
              </div> -->

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-1">
                                <label for="disaster">{{ $t('related_disaster') }}</label>
                                <Dropdown
                                    v-model="disasterTypeSelected"
                                    :options="disasterTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterTypeOptions">
                                        <div v-if="disasterTypeOptions.value">
                                            <div>{{ disasterTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterTypeOptions">
                                        <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="course">{{ $t('imp_training') }}</label>
                                <Dropdown
                                    v-model="courseSelected"
                                    :options="courseOptions"
                                    optionLabel="course_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="courseOptions">
                                        <div v-if="courseOptions.value">
                                            <div>{{ courseOptions.value.course_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ courseOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="courseOptions">
                                        <div class="MP_course_name">{{ courseOptions.option.course_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-7">
                                <div class="p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                        <label for="genDate">{{ $t('imp_gen') }}/{{ $t('imp_date') }}</label>
                                        <Dropdown v-model="selectedGenDate" :options="genDate" optionLabel="name">
                                            <template #value="genDate">
                                                <div v-if="genDate.value">
                                                    <div>{{ genDate.value.name }}</div>
                                                </div>
                                                <span v-else>
                                                    {{ genDate.placeholder }}
                                                </span>
                                            </template>
                                            <template #option="genDate">
                                                <div>{{ genDate.option.name }}</div>
                                            </template>
                                        </Dropdown>
                                    </div>
                                    <div class="p-field p-col-12 p-lg-8 p-mt-5">
                                        <InputText
                                            v-if="selectedGenDate.value == 'gen'"
                                            id="imp_searchby_gen"
                                            type="text"
                                            v-model="searchby"
                                            class="p-mt-2"
                                            style="margin-top: 4px !important"
                                        />
                                        <Calendar
                                            v-else
                                            class="p-mt-2"
                                            dateFormat="dd/mm/yy"
                                            :showButtonBar="true"
                                            :monthNavigator="true"
                                            :yearNavigator="true"
                                            yearRange="2000:2050"
                                            :locale="th"
                                            id="imp_searchby_date"
                                            v-model="searchby"
                                        ></Calendar>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-field-checkbox p-col-8 p-lg-6 p-mt-5">
                            <Checkbox id="check_update_info" name="check_update_info" value="1" v-model="check_update_info" />
                            <label for="check_update_info">{{ $t('imp_update_info') }}</label>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    v-if="window.width <= 430"
                                    @click="MobileClearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <Button
                                    v-else
                                    @click="clearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                                <!-- Doe โหลด โทรศัพท์ -->
                                <Button
                                    @click="searchManInfo()"
                                    :label="$t('searchBtn')"
                                    class="p-button-info"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="manInfo_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? manInfo_Table : []"
                :paginator="true"
                :lazy="true"
                :rows="lazyParams.rows"
                :totalRecords="lazyParams.totalRecords"
                :first="lazyParams.first"
                @page="onPage"
                scrollHeight="500px"
                dataKey="officer_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลกำลังคน-${date}`"
                :rowHover="true"
                :selection.sync="selectedManInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="manInfoModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedManInfo && selectedManInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                  <i class="pi pi-search" /><InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/5 -->
                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedManInfo.length === manInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedManInfo.some((item) => item.officer_id === slotProps.data.officer_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'"  :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.system_id }}</div>
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                    <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_img == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('18rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img == true">
                                <div v-if="dataTable.data.officer_image !== '' && dataTable.data.officer_image !== null && columns_img == true">
                                    <img
                                        :src="pickRecordImage(dataTable.data, 'officer_image')"
                                        @click="showImage(pickRecordImageRaw(dataTable.data, 'officer_image'))"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <Column
            field="officer_prefix_name"
            header=""
            :sortable="false"
            headerStyle="width: 0px"
            :hidden="true"
          >
            <template #body="dataTable">
              <div hidden>{{ dataTable.data.officer_id }}</div>
            </template>
          </Column>
  
          <Column
            field="officer_firstname"
            header=""
            :sortable="false"
            headerStyle="width: 0px"
            :hidden="true"
          >
            <template #body="dataTable">
              <div hidden>{{ dataTable.data.officer_id }}</div>
            </template>
          </Column>
  
          <Column
            field="officer_lastname"
            header=""
            :sortable="false"
            headerStyle="width: 0px"
            :hidden="true"
          >
            <template #body="dataTable">
              <div hidden>{{ dataTable.data.officer_id }}</div>
            </template>
          </Column> -->

                <div v-if="columns_officer_fullname == true">
                    <Column
                        field="officer_fullname"
                        :header="$t('imp_fullname')"
                        
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_officer_fullname == true">
                                {{ dataTable.data.officer_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_officer_position_name == true">
                    <Column
                        field="officer_position_name"
                        :header="$t('imp_position')"
                        
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_officer_position_name == true">
                                <div v-if="dataTable.data.officer_position_name == null || dataTable.data.officer_position_name == ''">-</div>
                                <div v-else>{{ dataTable.data.officer_position_name }}</div>
                            </div>

                            <!-- <div v-if="dataTable.data.officer_position == ''">-</div>
                <div v-else>{{ dataTable.data.officer_position }}</div> -->
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_level_name == true">
                    <Column
                        field="level_name"
                        :header="$t('imp_level')"
                        
                        :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_level_name == true">
                                <div v-if="dataTable.data.level_name == null" class="table_row">-</div>
                                <div v-else class="table_row">{{ dataTable.data.level_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column
                        field="organize_name"
                        :header="$t('organize_original')"
                        
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_organize_name == true">
                                {{ dataTable.data.organize_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_specialist_id == true">
                    <Column
                        field="specialist_id"
                        :header="$t('imp_specialication')"
                        
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_specialist_id == true">
                                {{ dataTable.data.specialist_id }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_officer_response_signal == true">
                    <Column
                        field="officer_response_signal"
                        :header="$t('imp_response_signal')"
                        
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_officer_response_signal == true">
                                <div v-if="dataTable.data.officer_response_signal == ''">-</div>
                                <div v-else>{{ dataTable.data.officer_response_signal }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_officer_mobile_phone == true">
                    <!-- <Column
            field="officer_mobile_phone"
            :header="$t('imp_phone_number')"
            
            headerStyle="width: 200px"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.officer_mobile_phone == ''">-</div>
              <div v-else>{{ dataTable.data.officer_mobile_phone }}</div>
            </template>
          </Column> -->
                    <Column
                        field="text_tel_detail"
                        :header="$t('imp_phone_number')"
                        
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_officer_mobile_phone == true">
                                <span v-html="dataTable.data.text_tel_detailHTML"></span>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <div v-if="columns_update_date == true"> 
          <Column
            field="update_date"
            :header="$t('imp_update_info_date')"
            
            :headerStyle="tableColSticky('220px','center','sticky','top')"
          >
            <template #body="dataTable">
              <div class="table_row" v-if="columns_update_date == true" style="text-align: center;">
                {{ dataTable.data.update_date }}
              </div>
            </template>
          </Column>
          </div>
          <div v-else>
              <Column :headerStyle="tableColNone()"></Column>
          </div> -->

                <div v-if="columns_user_fullname == true">
                    <Column
                        field="user_fullname"
                        :header="$t('imp_editor')"
                        
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_user_fullname == true">
                                {{ dataTable.data.user_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!-- columns_update_date || -->
                <div
                    v-if="
                        columns_user_fullname ||
                        columns_index ||
                        columns_img ||
                        columns_officer_fullname ||
                        columns_officer_position_name ||
                        columns_level_name ||
                        columns_organize_name ||
                        columns_specialist_id ||
                        columns_officer_response_signal ||
                        columns_officer_mobile_phone ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            manInfoModal = true;
                                            editData(dataTable.data.officer_id);
                                            temp = dataTable.data.officer_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.officer_id;
                                            deleteAt = '';
                                            alertDisplay(temp);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="manInfoModal"
            :style="{ width: '85%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('imp_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="imp_prefix_name">{{ $t('imp_prefix_name') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="imp_prefix_name"
                                :options="prefixOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                inputStyle="color: red;"
                                :class="{
                                    'p-invalid': error_imp_prefix_name && !imp_prefix_name
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="levelOptions">
                                    <div v-if="levelOptions.value">
                                        <div>{{ levelOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ levelOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="levelOptions">
                                    <div>{{ levelOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_imp_prefix_name && !imp_prefix_name">{{ $t('imp_prefix_name_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-5 p-mt-2">
                            <label for="imp_firstname">{{ $t('imp_firstname') }} <span class="required-input">*</span></label>
                            <InputText
                                id="imp_firstname"
                                type="text"
                                v-model="imp_firstname"
                                autofocus
                                required="true"
                                :class="{ 'p-invalid': error_imp_firstname && !imp_firstname }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_imp_firstname && !imp_firstname">{{ $t('imp_firstname_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-5 p-mt-2">
                            <label for="imp_lastname">{{ $t('imp_lastname') }} <span class="required-input">*</span></label>
                            <InputText
                                id="imp_lastname"
                                type="text"
                                v-model="imp_lastname"
                                :class="{ 'p-invalid': error_imp_lastname && !imp_lastname }"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_imp_lastname && !imp_lastname">{{ $t('imp_lastname_validate') }}</small>
                        </div>
                    </div>

                    <div class="p-grid">
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-col-12">
                                <div class="p-field p-col-7 p-lg-6 p-mt-2" style="margin-top: -5px">
                                    <label for="imp_organize">{{ $t('organize_original') }} <span class="required-input">*</span></label>
                                    <InputText
                                        id="imp_organize"
                                        type="text"
                                        v-model="imp_organize.name"
                                        disabled
                                        :class="{
                                            'p-invalid': error_imp_organize && !imp_organize.name
                                        }"
                                    />
                                    <small class="p-invalid" v-if="error_imp_organize && !imp_organize.name">{{ $t('imp_organize_validate') }}</small>
                                </div>
                                <div class="p-field p-lg-2">
                                    <div>
                                        <Button
                                            @click="showOrganize_Form = true"
                                            icon="pi pi-ellipsis-h"
                                            class="p-button-secondary p-mt-5 p-mr-2"
                                            ref="TextBox_3"
                                            @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                        />
                                        <Button
                                            @click="imp_organize = {}"
                                            icon="pi pi-times"
                                            class="p-button-danger p-mt-5"
                                            ref="TextBox_4"
                                            @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="p-formgrid p-grid p-col-12">
                                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                    <label for="level">{{ $t('imp_level') }}</label>
                                    <Dropdown
                                        v-model="imp_level"
                                        :options="levelOptions"
                                        optionLabel="system_name"
                                        :filter="true"
                                        :placeholder="$t('placeholderSelectBox')"
                                        :showClear="true"
                                        :clearFilterDropdown="dropdownClearFilerValue"
                                    >
                                        <template #value="levelOptions">
                                            <div v-if="levelOptions.value">
                                                <div>{{ levelOptions.value.system_name }}</div>
                                            </div>
                                            <span v-else>
                                                {{ levelOptions.placeholder }}
                                            </span>
                                        </template>
                                        <template #option="levelOptions">
                                            <div>{{ levelOptions.option.system_name }}</div>
                                        </template>
                                    </Dropdown>
                                </div>
                                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                    <label for="imp_position">{{ $t('imp_position') }}</label>
                                    <InputText
                                        id="imp_position"
                                        type="text"
                                        v-model="imp_position"
                                        ref="TextBox_5"
                                        @keyup.left="moveFocus($event, 'TextBox_4', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                    />
                                </div>

                                <div class="p-col-12 p-lg-4 p-mt-5" style="padding-top: 9.5px">
                                    <span hidden>{{ url }}</span>
                                    <div class="p-grid">
                                        <div class="p-col-8 p-lg-8">
                                            <Button
                                                @click="onFileChange"
                                                class="p-button-success"
                                                icon="pi pi-plus"
                                                label="เลือกไฟล์ภาพ"
                                                ref="TextBox_6"
                                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                                @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                                @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                                @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                            >
                                            </Button>

                                            <input
                                                style="visibility: hidden; display: none; text-overflow: ellipsis"
                                                type="file"
                                                id="imp_uploadImageFile"
                                                @change="onFileChange"
                                                class="inputzone"
                                                accept="image/*"
                                            />
                                        </div>
                                        <div class="p-col-4 p-lg-4" style="padding-top: 0">
                                            <Button
                                                @click="clearImage()"
                                                icon="pi pi-times"
                                                class="p-button-danger"
                                                style="width: auto"
                                                :label="$t('clearImage')"
                                                ref="TextBox_7"
                                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                                @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                                @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                            />
                                        </div>
                                    </div>

                                    <div id="preview">
                                        <img v-if="resolveImageSrc(url)" :src="resolveImageSrc(url)" />
                                    </div>
                                    <div id="imp_image" ref="imp_image" hidden></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2" style="margin-top: -5px">
                            <label for="imp_start_workDate">{{ $t('imp_start_workDate') }} <span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="imp_start_workDate"
                                v-model="imp_start_workDate"
                                :class="{
                                    'p-invalid': error_imp_start_workDate && !imp_start_workDate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_imp_start_workDate && !imp_start_workDate">{{
                                $t('imp_start_workDate_validate')
                            }}</small>
                        </div>

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="imp_phone_number">{{ $t("imp_phone_number") }}
                    <span class="required-input">*</span>
                </label>
                <InputText
                  id="imp_phone_number"
                  type="text"
                  v-model="imp_phone_number"
                  @input="acceptNumberPhone"
                  autofocus
                />
              </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="imp_phone_number">{{ $t("imp_phone_number") }}
                    <span class="required-input">*</span>
                </label>
                <InputText
                  id="imp_phone_number"
                  type="text"
                  v-model="imp_phone_number"
                 
                  autofocus
                />
              </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="imp_mobile_phone_number">{{
                  $t("mobile_phone_number")
                }}<span class="required-input">*</span></label>
                <InputText
                  id="imp_mobile_phone_number"
                  type="text"
                  v-model="imp_mobile_phone_number"
                  @input="acceptNumberPhone_2"
                  autofocus
                />
              </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="imp_mobile_phone_number">{{
                  $t("mobile_phone_number")
                }}<span class="required-input">*</span></label>
                <InputText
                  id="imp_mobile_phone_number"
                  type="text"
                  v-model="imp_mobile_phone_number"
                  
                  autofocus
                />
              </div> -->

                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="imp_fax">{{ $t('imp_fax') }} <span class="required-input"></span></label>
                            <InputText
                                id="imp_fax"
                                type="text"
                                v-model="imp_fax"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-5" style="margin-bottom: 0.8rem">
                            <label for="contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)<span class="required-input">*</span></label>
                            <InputText
                                id="contact_phone"
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                :class="{
                                    'p-invalid': error_contact_phone && contact_phone.length !== 12
                                }"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone && contact_phone.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก
                            </small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4" style="margin-bottom: 0.8rem">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)<span class="required-input">*</span></label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                :class="{
                                    'p-invalid': error_contact_phone_office && contact_phone_office.length !== 11
                                }"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_11' : 'TextBox_12', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div
                            class="p-field p-col-12 p-lg-3"
                            style="margin-bottom: 0.8rem"
                            v-if="contact_phone_office && contact_phone_office !== '-'"
                        >
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-3" style="margin-bottom: 0.8rem" v-else>
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                disabled
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                placeholder="กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="imp_email">{{ $t('email') }} </label>
                            <InputText
                                id="imp_email"
                                type="text"
                                v-model="imp_email"
                                :class="{ 'p-invalid': error_email_format == true }"
                                ref="TextBox_12"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_11' : 'TextBox_10', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_email_format == true">กรุณาระบุอีเมลให้ถูกต้อง</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="imp_radio_signal">{{ $t('imp_radio_signal') }}</label>
                            <InputText
                                id="imp_radio_signal"
                                type="text"
                                v-model="imp_radio_signal"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="imp_response_signal">{{ $t('imp_response_signal') }}</label>
                            <InputText
                                id="imp_response_signal"
                                type="text"
                                v-model="imp_response_signal"
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_11' : 'TextBox_8', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-5 p-mt-2">
                            <label for="imp_secretary_name">{{ $t('imp_secretary_name') }}<span class="required-input"> </span></label>
                            <InputText
                                id="imp_secretary_name"
                                type="text"
                                v-model="imp_secretary_name"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="imp_secretary_phone">{{
                  $t("imp_secretary_phone")
                }}</label>
                <InputText
                  id="imp_secretary_phone"
                  type="text"
                  v-model="imp_secretary_phone"
                  @input="acceptNumberPhone_3"
                  autofocus
                />
              </div> -->

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="imp_secretary_phone">{{ $t('imp_secretary_phone') }}<span class="required-input"> </span></label>
                            <InputText
                                id="imp_secretary_phone"
                                type="text"
                                v-model="imp_secretary_phone"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>

                        <!-- <div class="p-field p-col-12 p-lg-2 p-mt-2">
                <label for="imp_update_info_date">{{
                  $t("imp_update_info_date")
                }}</label>
                <InputText
                  id="imp_update_info_date"
                  type="text"
                  v-model="imp_update_info_date"
                  disabled
                />
              </div> -->

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-lg-12 p-mt-2">
                        <div class="p-field p-col">
                            <label for="imp_detail">{{ $t('imp_detail') }}</label>
                            <Textarea
                                id="imp_detail"
                                type="text"
                                v-model="imp_detail"
                                ref="TextBox_17"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-field-checkbox p-col-12 p-justify-end">
                        <Checkbox id="imp_update_info" name="imp_update_info" value="1" v-model="imp_update_info" />
                        <label for="imp_update_info">{{ $t('imp_update_info') }}</label>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <label for="imp_specialication">{{ $t('imp_specialication') }}</label>
                            <MultiSelect
                                v-model="imp_special"
                                :options="specialOptions"
                                optionLabel="system_name"
                                :placeholder="$t('placeholderSelectBox')"
                                :filter="true"
                                class="multiselect-custom"
                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                        <div>{{ option.system_name }}</div>
                                    </div>
                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                        {{ $t('placeholderSelectBox') }}
                                    </template>
                                </template>
                                <template #option="slotProps">
                                    <div class="item">
                                        <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                                    </div>
                                </template>
                            </MultiSelect>
                        </div>

                        <div class="p-field p-col-12 p-mt-2">
                            <DataTable
                                :value="special_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="system_name" :header="$t('imp_specialication')" :sortable="true" :headerStyle="{ width: '15rem' }">
                                    <template #body="dataTable">
                                        {{ dataTable.data.system_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        specialDelete = dataTable.data;
                                                        deleteAt = 'special-table';
                                                        alertDisplay(specialDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col-12 p-mt-2">
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <label for="disasterOptions">{{ $t('related_disaster') }}</label>
                            <MultiSelect
                                v-model="imp_disaster"
                                :options="disasterTypeOptions"
                                optionLabel="system_name"
                                :placeholder="$t('placeholderSelectBox')"
                                :filter="true"
                                class="multiselect-custom"
                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                        <div>{{ option.system_name }}</div>
                                    </div>
                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                        {{ $t('placeholderSelectBox') }}
                                    </template>
                                </template>
                                <template #option="slotProps">
                                    <div class="item">
                                        <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                                    </div>
                                </template>
                            </MultiSelect>
                        </div>

                        <div class="p-field p-col-12 p-mt-1">
                            <DataTable
                                :value="disaster_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="system_name" :header="$t('support_disaster')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div>
                                            {{ dataTable.data.system_name }}
                                        </div>
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        disasterDelete = dataTable.data;
                                                        deleteAt = 'disaster-table';
                                                        alertDisplay(disasterDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10">
                            <label>{{ $t('imp_history_training') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2">
                            <Button
                                @click="showCourseHistory = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_18"
                                @keyup.left="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_17', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_19', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="history_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="course_name" :header="$t('imp_training')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.course_name }}
                                    </template>
                                </Column>
                                <Column field="course_level" :header="$t('imp_level')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.course_level }}
                                    </template>
                                </Column>
                                <Column field="gen" :header="$t('itc_generation')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.gen }}
                                    </template>
                                </Column>
                                <Column field="start_date" :header="$t('itc_training_date')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        เริ่ม {{ Format_Time(dataTable.data.start_date) }} <br />
                                        ถึง {{ Format_Time(dataTable.data.end_date) }}
                                    </template>
                                </Column>
                                <Column field="remark" :header="$t('remark')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.remark }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <Button
                                            @click="
                                                displayConfirmation = true;
                                                historyDelete = dataTable.data;
                                                deleteAt = 'history-table';
                                            "
                                            icon="pi pi-trash"
                                            :label="$t('deleteBtn')"
                                            class="p-button-rounded p-button-danger"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- :contentStyle="{ 'overflow-y': 'auto' }" -->
        <Dialog :modal="true" :visible.sync="showCourseHistory" :style="{ width: '75%' }" :header="headerDetail">
            <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-lg-3 p-mb-2">
                        <label for="level">{{ $t('imp_level') }} <span class="required-input"></span></label>
                        <Dropdown
                            v-model="courseLevelSelected"
                            :options="courseLevelOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="courseLevelOptions">
                                <div v-if="courseLevelOptions.value">
                                    <div>{{ courseLevelOptions.value.system_name }}</div>
                                </div>
                                <span v-else>
                                    {{ courseLevelOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="courseLevelOptions">
                                <div>{{ courseLevelOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-lg-6 p-mb-2">
                        <label for="imp_course_name">{{ $t('itc_course_name') }} <span class="required-input">*</span></label>
                        <Dropdown
                            v-model="imp_course_name"
                            :options="courseOptions"
                            optionLabel="course_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :class="{ 'p-invalid': error_courseSelected && !imp_course_name }"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="courseOptions">
                                <div v-if="courseOptions.value">
                                    <div>{{ courseOptions.value.course_name }}</div>
                                </div>
                                <span v-else>
                                    {{ courseOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="courseOptions">
                                <div class="MP_courseOptions">{{ courseOptions.option.course_name }}</div>
                            </template>
                        </Dropdown>
                        <small class="p-invalid" v-if="error_courseSelected && !imp_course_name">{{ $t('itc_course_name_validate') }}</small>
                    </div>
                    <div class="p-field p-col-3 p-lg-1" style="width: 6rem">
                        <Button @click="searchCourse()" :label="$t('searchBtn')" class="p-button-info p-mb-2 p-mt-5" />
                    </div>
                    <div class="p-field p-col-3 p-lg-1" style="width: 6rem">
                        <Button @click="addCourse(imp_course_name)" :label="$t('selectBtn')" class="p-button-success p-mb-2 p-mt-5" />
                    </div>
                </div>
            </div>
            <!-- Course detail -->
            <DataTable
                :value="trainingCourse_Table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                ref="dt"
                :metaKeySelection="true"
                :rowHover="true"
                :selection.sync="selectedTrainingData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <template #empty>{{ $t('TableEmpty') }}</template>
                <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                <Column field="gen" :header="$t('itc_generation')" :sortable="true" headerStyle="width: 10rem">
                    <template #body="dataTable">
                        {{ dataTable.data.gen }}
                    </template>
                </Column>
                <Column field="start_date" :header="$t('itc_training_date')" :sortable="true" headerStyle="width: 10rem">
                    <template #body="dataTable">
                        เริ่ม {{ Format_Time(dataTable.data.start_date) }} <br />
                        ถึง {{ Format_Time(dataTable.data.end_date) }}
                    </template>
                </Column>
                <Column field="remark" :header="$t('remark')" :sortable="true" headerStyle="width: 12rem">
                    <template #body="dataTable">
                        {{ dataTable.data.remark }}
                    </template>
                </Column>
            </DataTable>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-man',
    components: {
        organizeTable,
        organizeForm,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            searchResults: [], // Store full search results
            currentPage: 1,
            isSearchMode: false,

            lazyParams: {
                first: 0,
                rows: 50, // Default to match your current rows
                page: 1,
                totalRecords: 0
            },

            cache: {},
            temp: null,
            displayBasic2: false,
            imgTable: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),
            // Doe ค้นหา  2/6
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            th: this.$thaidate,
            fullname: '',
            selectedOrganize: {},
            selectedGenDate: { name: this.$i18n.t('imp_gen'), value: 'gen' },
            genDate: [
                { name: this.$i18n.t('imp_gen'), value: 'gen' },
                { name: this.$i18n.t('imp_date'), value: 'date' }
            ],
            searchby: '',
            check_update_info: [],
            levelOptions: [],
            levelSelected: null,
            disasterTypeOptions: [],
            disasterTypeSelected: null,
            courseOptions: [],
            courseSelected: null,
            error_courseSelected: false,
            courseLevelOptions: [],
            specialOptions: [],
            prefixOptions: [],
            selectedTrainingData: null,
            displayConfirmation: false,
            specialDelete: {},
            disasterDelete: {},
            historyDelete: {},
            deleteAt: '',
            filters: {},
            selectedManInfo: [],
            manInfo_Table: [],
            trainingCourse_Table: [],

            showOrganize: false,
            showOrganize_Form: false,
            showCourseHistory: false,
            selectedData: '',
            manInfoModal: false,
            imp_prefix_name: null,
            imp_firstname: '',
            imp_lastname: '',
            url: null,
            imp_level: null,
            imp_organize: {},
            imp_start_workDate: '',
            imp_update_info: [],
            imp_position: '',
            imp_phone_number: '',
            imp_mobile_phone_number: '',
            imp_fax: '',
            imp_email: '',
            imp_radio_signal: '',
            imp_response_signal: '',
            imp_secretary_name: '',
            imp_secretary_phone: '',
            imp_update_info_date: '',
            imp_update_info_date_save: '',
            imp_detail: '',

            courseLevelSelected: null,
            imp_course_name: null,
            imp_disaster: null,
            disaster_table: [],
            imp_special: null,
            special_table: [],
            history_table: [],
            error_imp_prefix_name: false,
            error_imp_firstname: false,
            error_imp_lastname: false,
            error_imp_organize: false,
            error_imp_start_workDate: false,
            header: this.$i18n.t('imp_modal_title_add'),
            headerDetail: this.$i18n.t('imp_modal_title_add_trainingHistory'),

            check_duplicate: '',
            error_email_format: false,
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            date_create_form: '',
            date_update_form: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อ-นามสกุล',
                    textShow: ''
                },
                {
                    DataName: 'ระดับ',
                    textShow: ''
                },
                {
                    DataName: 'สาธารณภัยที่เกี่ยวข้อง',
                    textShow: ''
                },
                {
                    DataName: 'หลักสูตรการฝึกอบรม',
                    textShow: ''
                },
                {
                    DataName: 'รุ่นที่/วันที่',
                    textShow: ''
                },
                {
                    DataName: 'ต้องปรับปรุงข้อมูล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลกำลังคน',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 60,
            PDF_FontHeaderVer: 10,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },
                officer_fullname: { cellWidth: 55 },
                level_name: { cellWidth: 45 },
                organize_name: { cellWidth: 60 },
                specialist_id: { cellWidth: 40 },
                officer_response_signal: { cellWidth: 45 },
                // officer_mobile_phone:{cellWidth:55},
                text_tel_detail: { cellWidth: 60 },
                // update_date:{cellWidth:65}
                user_fullname: { cellWidth: 45 },
                date_update_ddmmyy: { cellWidth: 65 }
            },

            PDF_minCellWidthHor: 80,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 9,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                // officer_fullname: {cellWidth:75},
                // officer_position_name:{cellWidth:75},
                level_name: { cellWidth: 50 },
                organize_name: { cellWidth: 75 },
                specialist_id: { cellWidth: 70 },
                officer_response_signal: { cellWidth: 55 },
                // officer_mobile_phone:{cellWidth:65},
                text_tel_detail: { cellWidth: 60 },
                // update_date:{cellWidth:65},
                user_fullname: { cellWidth: 50 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'รูปภาพ', dataKey: 'officer_image' },
                { title: 'ชื่อ-นามสกุล', dataKey: 'officer_fullname' },
                { title: 'ตำแหน่ง', dataKey: 'officer_position_name' },
                { title: 'ระดับ', dataKey: 'level_name' },
                { title: 'ต้นสังกัด', dataKey: 'organize_name' },
                { title: 'ความเชี่ยวชาญ', dataKey: 'specialist_id' },
                { title: 'สัญาณเรียกขาน', dataKey: 'officer_response_signal' },
                // {title: "หมายเลขโทรศัพท์", dataKey: "officer_mobile_phone"},
                { title: 'หมายเลขโทรศัพท์', dataKey: 'text_tel_detail' },
                // {title: "วันที่ปรับปรุงข้อมูลล่าสุด", dataKey: "update_date"},
                { title: 'ผู้แก้ไข', dataKey: 'user_fullname' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_officer_fullname: true,
            columns_officer_position_name: true,
            columns_level_name: true,
            columns_organize_name: true,
            columns_specialist_id: true,
            columns_officer_response_signal: true,
            columns_officer_mobile_phone: true,
            columns_update_date: true,
            columns_user_fullname: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: 'แนวตั้ง',
                    command: async () => {
                        try {
                            await this.searchAllManInfo(); // Add your search method here
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'officer_image';
                            });

                            const Body_setCenter = ['index', 'level_name', 'officer_response_signal'];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.searchAllManInfo(); // Add your search method here
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'officer_image';
                            });

                            const Body_setCenter = ['index', 'level_name', 'officer_response_signal'];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        filter(newVal) {
            if (!newVal?.trim()) {
                this.isSearchMode = false;
            }
        },

        async showCourseHistory(val) {
            if (val == false) {
                this.trainingCourse_Table = [];
                this.imp_course_name = null;
                this.courseLevelSelected = null;
                this.error_courseSelected = false;
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => {
                        (this.courseOptions = response.data.data),
                            this.courseOptions.splice(0, 0, {
                                course_id: 'getall',
                                course_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                if (this.history_table != []) {
                    this.selectedTrainingData = this.history_table;
                }
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-06' }
                    })
                    .then((response) => {
                        this.courseLevelOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => (this.courseOptions = response.data.data));
            }
        },

        async manInfoModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.imp_prefix_name != null &&
                    this.imp_firstname != '' &&
                    this.imp_lastname != '' &&
                    this.imp_organize.name != undefined
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            (this.imp_prefix_name = null), (this.imp_firstname = '');
                            this.imp_lastname = '';
                            this.url = null;
                            this.imp_organize = {};
                            this.imp_start_workDate = '';
                            this.imp_update_info = '';
                            this.imp_position = '';
                            this.imp_phone_number = '';
                            this.imp_mobile_phone_number = '';
                            this.imp_fax = '';
                            this.imp_email = '';
                            this.imp_radio_signal = '';
                            this.imp_response_signal = '';
                            this.imp_secretary_name = '';
                            this.imp_secretary_phone = '';
                            this.imp_detail = '';
                            this.imp_level = null;
                            this.imp_course_name = null;
                            this.imp_disaster = null;
                            this.disaster_table = [];
                            this.imp_special = null;
                            this.special_table = [];
                            this.history_table = [];
                            this.error_imp_prefix_name = false;
                            this.error_imp_firstname = false;
                            this.error_imp_lastname = false;
                            this.error_imp_organize = false;
                            this.error_imp_start_workDate = false;
                            this.error_email_format = false;

                            this.contact_phone = '';
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.date_create_form = '';
                            this.date_update_form = '';

                            // this.closeAllModal();
                            // this.clearData();
                            this.manInfoModal = false;
                        } else {
                            this.manInfoModal = true;
                        }
                    });
                } else {
                    // สลับมาอยู่บน
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-08' }
                        })
                        .then((response) => {
                            (this.levelOptions = response.data.data),
                                this.levelOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/course`, {
                            body: { topic: 'get-option' }
                        })
                        .then((response) => {
                            (this.courseOptions = response.data.data),
                                this.courseOptions.splice(0, 0, {
                                    course_id: 'getall',
                                    course_name: this.$i18n.t('selectAll')
                                });
                        });
                    // this.clearData();
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.imp_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-07' }
                    })
                    .then((response) => {
                        this.specialOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-08' }
                    })
                    .then((response) => {
                        this.levelOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-13' }
                    })
                    .then((response) => {
                        this.prefixOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: { topic: 'get-option' }
                    })
                    .then((response) => (this.courseOptions = response.data.data));

                if (this.selectedData == '') {
                    const lastest = new Date();
                    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(lastest);
                    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(lastest);
                    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(lastest);
                    var ye_th = Number(ye) + 543;
                    this.imp_update_info_date = `${da}/${mo}/${ye_th}`;
                    this.imp_update_info_date_save = `${ye}-${mo}-${da}`;
                }
                // else{

                //   this.imp_start_workDate = this.formatDateString(this.imp_start_workDate)

                // }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.manInfoModal = true;
            }
        },

        DCM(val) {
            if (val == true) {
                this.manInfoModal = true;
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.officer_level_id == 'null') {
                    this.imp_level = null;
                } else {
                    this.imp_level = {
                        system_id: val.officer_level_id,
                        system_name: val.level_name
                    };
                }
            }
        },

        imp_start_workDate(val) {
            if (val == null) {
                this.imp_start_workDate = '';
            }
        },

        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.manInfo_Table = [];
            } else {
                this.manInfo_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },

        // check_duplicate(val) {
        //   if (val == "duplicate") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลกำลังคนไม่สำเร็จ",
        //     //   detail: "มีข้อมูลกำลังคนในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //      this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลกำลังคนไม่สำเร็จ",
        //           text: "มีข้อมูลกำลังคนในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลกำลังคน",
        //     //   life: 3000,
        //     // });
        //      this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลกำลังคน",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },

        imp_special(val) {
            if (val != null) {
                this.special_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.special_table.push(val[i]);
                }
            }
        },

        imp_disaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },
        selectedGenDate(val) {
            if (val.value !== 'gen') {
                this.searchby = '';
            } else {
                this.searchby = '';
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4

        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedManInfo.map((item) => ({
                    officer_id: item.officer_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/officer?user=${userId}`, {
                    body: {
                        topic: 'edit-officer_date_multiple',
                        selectedManInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.manInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลกำลังคนจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchManInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedManInfo = [...this.manInfo_Table];
            } else {
                this.selectedManInfo = [];
            }
            this.$emit('selectedManInfo', this.selectedManInfo);
            // console.log('selectedManInfo', this.selectedManInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedManInfo.some((item) => item.officer_id === row.officer_id)) {
                    this.selectedManInfo.push(row);
                }
            } else {
                this.selectedManInfo = this.selectedManInfo.filter((item) => item.officer_id !== row.officer_id);
            }
            this.$emit('selectedManInfo', this.selectedManInfo);
            // console.log('selectedManInfo', this.selectedManInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchManInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_4') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_7') &&
                    !this.isFocused('TextBox_18') &&
                    !this.isFocused('TextBox_19') &&
                    !this.isFocused('TextBox_20')
                ) {
                    this.saveData();
                }
            }
        },
        async exportCSV() {
            await this.searchAllManInfo();
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: { topic: 'get-option' }
                })
                .then((response) => {
                    (this.courseOptions = response.data.data),
                        this.courseOptions.splice(0, 0, {
                            course_id: 'getall',
                            course_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-08' }
                })
                .then((response) => {
                    (this.levelOptions = response.data.data),
                        this.levelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        //ok

        async search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay API calls
            this.searchTimeout = setTimeout(async () => {
                this.error = null;

                // If filter is empty, reset to normal view
                if (!this.filter?.trim()) {
                    this.isSearchMode = false;
                    await this.searchManInfo();
                    return;
                }

                // Set search mode flag to true when searching
                this.isSearchMode = true;

                // Build search fields based on visible columns
                const searchFields = [
                    { enabled: this.columns_officer_fullname, field: 'officer_fullname' },
                    { enabled: this.columns_officer_position_name, field: 'officer_position_name' },
                    { enabled: this.columns_level_name, field: 'level_name' },
                    { enabled: this.columns_specialist_id, field: 'specialist_id' },
                    { enabled: this.columns_officer_response_signal, field: 'officer_response_signal' },
                    { enabled: this.columns_officer_mobile_phone, field: 'text_tel_detail' },
                    { enabled: this.columns_organize_name, field: 'organize_name' },
                    { enabled: this.columns_date_create, field: 'date_create_ddmmyy' },
                    { enabled: this.columns_date_update, field: 'date_update_ddmmyy' }
                ]
                    .filter(({ enabled }) => enabled)
                    .map(({ field }) => field);

                if (!searchFields.length) {
                    this.error = 'Please enable at least one search column';
                    return;
                }

                this.loading = true; // Set loading state

                try {
                    const response = await this.axios.post(`${this.$url_service}/initial/officer`, {
                        body: {
                            topic: 'filter-table',
                            filter: this.filter,
                            fields: searchFields,
                            pagination: {
                                page: this.lazyParams.page || 1,
                                limit: this.lazyParams.rows || 10
                            },
                            userOrg: this.checkPermission() ? null : this.getUserOrganize()
                        }
                    });

                    // Only update data if we're still in search mode
                    // (user might have cleared the filter during API call)
                    if (this.isSearchMode) {
                        // Process and format the search results
                        if (response.data && response.data.data) {
                            this.manInfo_Table = response.data.data;

                            // Process specialist_id data
                            for (let index = 0; index < this.manInfo_Table.length; index++) {
                                const element = this.manInfo_Table[index].specialist_id;
                                if (element == '[]' || element == []) {
                                    this.manInfo_Table[index].specialist_id = '-';
                                } else {
                                    try {
                                        let dataGetSpecial = JSON.parse(element);
                                        var specialistNameData = '';
                                        for (let index = 0; index < dataGetSpecial.length; index++) {
                                            const elementSpecial = dataGetSpecial[index].system_name;
                                            specialistNameData += `${elementSpecial} `;
                                        }
                                        this.manInfo_Table[index].specialist_id = specialistNameData.trim();
                                    } catch (e) {
                                        this.manInfo_Table[index].specialist_id = element;
                                    }
                                }
                            }

                            // Format date values
                            for (let i = 0; i < this.manInfo_Table.length; i++) {
                                if (this.manInfo_Table[i].update_date) {
                                    try {
                                        const element = this.manInfo_Table[i].update_date.split('/');
                                        let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
                                        let result_DateStart = dateNew.toLocaleDateString('th-TH', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        });
                                        this.manInfo_Table[i].update_date = result_DateStart;
                                    } catch (e) {
                                        // Keep original date if parsing fails
                                    }
                                }
                            }

                            // Apply any additional formatting
                            this.formatData(this.manInfo_Table);

                            // Update pagination information
                            this.lazyParams.totalRecords = response.data.total || 0;
                            this.currentPage = this.lazyParams.page;
                        } else {
                            // No results
                            this.manInfo_Table = [];
                            this.lazyParams.totalRecords = 0;
                        }
                    }
                } catch (error) {
                    console.error('Search error:', error);
                    this.error = 'Failed to fetch data. Please try again.';
                    this.isSearchMode = false;
                    // Revert to normal search if API search fails
                    await this.searchManInfo();
                } finally {
                    this.loading = false;

                    // Restore focus to the search input after the search completes
                    this.$nextTick(() => {
                        if (this.searchInputRef) {
                            this.searchInputRef.focus();
                            const length = this.searchInputRef.value.length;
                            this.searchInputRef.setSelectionRange(length, length);
                        }
                    });
                }
            }, 400);
        },

        updateIndexes() {
            this.manInfo_Table.forEach((item, index) => {
                item.index = index + 1;
            });
        },

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-08' }
                })
                .then((response) => {
                    (this.levelOptions = response.data.data),
                        this.levelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            if (this.columns_disabled == true) {
                this.manInfo_Table = this.cloneTable;
            } else {
                this.manInfo_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: { topic: 'get-option' }
                })
                .then((response) => {
                    (this.courseOptions = response.data.data),
                        this.courseOptions.splice(0, 0, {
                            course_id: 'getall',
                            course_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },

        formatData(data) {
            const startIndex = (this.lazyParams.page - 1) * this.lazyParams.rows;
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = startIndex + index + 1;
                if (
                    data[index].officer_position_name == null ||
                    data[index].officer_position_name == 'null' ||
                    data[index].officer_position_name == ''
                ) {
                    data[index].officer_position_name = '-';
                }
                if (data[index].level_name == null || data[index].level_name == 'null' || data[index].level_name == '') {
                    data[index].level_name = '-';
                }
                if (data[index].specialist_id == null || data[index].specialist_id == 'null' || data[index].specialist_id == '') {
                    data[index].specialist_id = '-';
                } else if (!this.isSearchMode && Array.isArray(data[index].specialist_id) && data[index].specialist_id.length > 0) {
                    data[index].specialist_id = data[index].specialist_id.map((specialist) => specialist.system_name).join(', ');
                }
                if (
                    data[index].officer_response_signal == null ||
                    data[index].officer_response_signal == 'null' ||
                    data[index].officer_response_signal == ''
                ) {
                    data[index].officer_response_signal = '-';
                }
                if (
                    data[index].officer_mobile_phone == null ||
                    data[index].officer_mobile_phone == 'null' ||
                    data[index].officer_mobile_phone == ''
                ) {
                    data[index].officer_mobile_phone = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        acceptNumberPhone_4() {
            var x = this.imp_secretary_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.imp_secretary_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.manInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        clearImage() {
            this.url = null;
            document.getElementById('imp_uploadImageFile').value = '';
        },

        onFileChange(e) {
            document.getElementById('imp_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('imp_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('imp_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.manInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.imp_organize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchCourse() {
            if (this.imp_course_name == null) {
                this.error_courseSelected = true;
            } else {
                await this.axios
                    .post(`${this.$url_service}/initial/course`, {
                        body: {
                            topic: 'search-history-table',
                            course_name: this.imp_course_name.course_name,
                            level: this.courseLevelSelected
                        }
                    })
                    .then((response) => (this.trainingCourse_Table = response.data.data));
            }
        },

        async searchAllManInfo() {
            this.isSearchMode = false;

            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            // console.log("1111")
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            var search_key;
            if (this.selectedGenDate.value == 'date') {
                if (this.searchby == '') {
                    search_key = '';
                } else {
                    const search = new Date(this.searchby);
                    const ye_s = new Intl.DateTimeFormat('en', {
                        year: 'numeric'
                    }).format(search);
                    const mo_s = new Intl.DateTimeFormat('en', {
                        month: '2-digit'
                    }).format(search);
                    const da_s = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(search);
                    search_key = `${da_s}/${mo_s}/${ye_s}`;
                }
            } else if (this.selectedGenDate.value == 'gen') {
                search_key = this.searchby;
            } else {
                search_key = '';
            }

            // console.log('this.equipment_name', this.equipment_name);
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            // console.log('this.getUserOrganize()', this.getUserOrganize());
            // console.log('this.checkPermission()', this.checkPermission());

            await this.axios
                .post(`${this.$url_service}/initial/officer`, {
                    body: {
                        topic: 'search-all-table',
                        name: this.fullname,
                        // organize: this.checkPermission()
                        //   ? this.selectedOrganize
                        //   : this.getUserOrganize(),
                        //  this.checkPermission() ==  true ให้ใช้ค่า  this.selectedOrganize ex. { id: 'or-000075', name: 'กองปฏิบัติการดับเพลิงและกู้ภัย 6' }
                        //  this.checkPermission() ==  false ให้ใช้ค่า  this.getUserOrganize() ex. or-000075
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        // organize: this.checkPermission() ? userSelectedOrganize : this.getUserOrganize(),
                        level: this.levelSelected,
                        disaster: this.disasterTypeSelected,
                        course: this.courseSelected,
                        search: search_key,
                        update: this.check_update_info,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        userOrg
                    }
                })
                .then((response) => {
                    this.manInfo_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    // console.log('this.manInfo_Table= ',this.manInfo_Table);
                    for (let index = 0; index < this.manInfo_Table.length; index++) {
                        const element = this.manInfo_Table[index].specialist_id;
                        // console.log('element= ',element);
                        if (element == '[]' || element == []) {
                            this.manInfo_Table[index].specialist_id = '-';
                        } else {
                            let dataGetSpecial = JSON.parse(this.manInfo_Table[index].specialist_id);
                            // console.log('dataGetSpecial ',dataGetSpecial);
                            var specialistNameData = '';
                            for (let index = 0; index < dataGetSpecial.length; index++) {
                                const elementSpecial = dataGetSpecial[index].system_name;
                                // console.log('elementSpecial= ',elementSpecial);
                                specialistNameData += `${elementSpecial} `;
                            }
                            this.manInfo_Table[index].specialist_id = specialistNameData;
                        }
                    }
                    // Doe : เพิ่ม ลำดับ 4/4
                    for (let i = 0; i < this.manInfo_Table.length; i++) {
                        this.manInfo_Table[i]['index'] = i + 1;
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.manInfo_Table);
                    // this.search()

                    this.setSearchText_Footer();
                });

            if (this.columns_disabled == true) {
                this.manInfo_Table = this.cloneTable;
            } else {
                this.manInfo_Table = [];
            }

            this.searchby_date = '';
            this.searchby_gen = '';
            this.loading = false;
        },

        async searchManInfo() {
            this.isSearchMode = false;

            try {
                if (!this.checkToken()) {
                    return;
                }

                this.ms = true;
                this.cloneTable = [];
                this.loading = true;

                const userOrg = this.checkPermission() ? null : this.getUserOrganize();

                // Format search key
                let search_key = '';
                if (this.selectedGenDate.value == 'date' && this.searchby) {
                    const search = new Date(this.searchby);
                    const ye_s = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(search);
                    const mo_s = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(search);
                    const da_s = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(search);
                    search_key = `${da_s}/${mo_s}/${ye_s}`;
                } else if (this.selectedGenDate.value == 'gen') {
                    search_key = this.searchby;
                }

                // Handle organization selection
                let userSelectedOrganize = JSON.stringify(this.selectedOrganize);
                if (userSelectedOrganize != '{}') {
                    userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
                } else {
                    userSelectedOrganize = this.selectedOrganize;
                }

                const response = await this.axios.post(`${this.$url_service}/initial/officer`, {
                    body: {
                        topic: 'search-table',
                        name: this.fullname,
                        level: this.levelSelected,
                        disaster: this.disasterTypeSelected,
                        course: this.courseSelected,
                        search: search_key,
                        update: this.check_update_info,
                        organize: this.organize_table,
                        userOrg,
                        pagination: {
                            page: this.lazyParams.page,
                            limit: this.lazyParams.rows
                        }
                    }
                });

                if (response.data) {
                    this.manInfo_Table = response.data.data;
                    this.cloneTable = response.data.data;
                    this.lazyParams.totalRecords = response.data.total;

                    // Process specialist IDs
                    this.manInfo_Table.forEach((item, index) => {
                        if (item.specialist_id == '[]' || item.specialist_id == []) {
                            item.specialist_id = '-';
                        } else {
                            const dataGetSpecial = JSON.parse(item.specialist_id);
                            item.specialist_id = dataGetSpecial.map((s) => s.system_name).join(' ');
                        }
                        item.index = index + 1;
                    });

                    await this.formatData(this.manInfo_Table);
                    this.setSearchText_Footer();
                }

                if (this.columns_disabled) {
                    this.manInfo_Table = this.cloneTable;
                } else {
                    this.manInfo_Table = [];
                }

                this.searchby_date = '';
                this.searchby_gen = '';
            } catch (error) {
                console.error('Search error:', error);
            } finally {
                this.loading = false;
            }
        },

        onPage(event) {
            const newPage = Math.floor(event.first / event.rows) + 1;

            this.lazyParams = {
                first: event.first,
                rows: event.rows,
                page: newPage,
                totalRecords: this.lazyParams.totalRecords
            };

            // Only fetch new data if page actually changed
            if (newPage !== this.currentPage) {
                this.currentPage = newPage;
                if (this.isSearchMode) {
                    this.search();
                } else {
                    this.searchManInfo();
                }
            }
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.fullname !== '' ||
                this.levelSelected !== null ||
                this.disasterTypeSelected !== null ||
                this.courseSelected !== null ||
                this.checkNull_String(this.searchby) ||
                this.check_update_info.length !== 0
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงาน' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อ-นามสกุล' && this.fullname !== '') {
                        element.textShow = this.fullname;
                    }
                    if (element.DataName === 'ระดับ' && this.levelSelected !== null) {
                        element.textShow = this.levelSelected.system_name;
                    }
                    if (element.DataName === 'สาธารณภัยที่เกี่ยวข้อง' && this.disasterTypeSelected !== null) {
                        element.textShow = this.disasterTypeSelected.system_name;
                    }
                    if (element.DataName === 'หลักสูตรการฝึกอบรม' && this.courseSelected !== null) {
                        element.textShow = this.courseSelected.course_name;
                    }
                    if (element.DataName === 'รุ่นที่/วันที่' && this.checkNull_String(this.searchby)) {
                        element.textShow = `${this.selectedGenDate.value === 'date' ? 'วันที่ ' : 'รุ่นที่ '} ${this.check_selectedGenDate(
                            this.selectedGenDate
                        )}`;
                    }
                    if (element.DataName === 'ต้องปรับปรุงข้อมูล' && this.check_update_info.length !== 0) {
                        element.textShow = this.check_update_info[0];
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        check_selectedGenDate(data) {
            if (data.value === 'date') {
                return this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.searchby)), 'string');
            } else {
                return this.searchby;
            }
        },
        checkNull_String(info) {
            if (info !== null && info !== '') {
                return true;
            } else {
                return false;
            }
        },
        addCourse() {
            this.showCourseHistory = false;
            this.history_table = [];
            for (let i = 0; i < this.selectedTrainingData.length; i++) {
                this.history_table.push({
                    course_id: this.selectedTrainingData[i].course_id,
                    course_name: this.selectedTrainingData[i].course_name,
                    course_level: this.selectedTrainingData[i].course_level,
                    gen: this.selectedTrainingData[i].gen,
                    start_date: this.selectedTrainingData[i].start_date,
                    end_date: this.selectedTrainingData[i].end_date,
                    remark: this.selectedTrainingData[i].remark
                });
            }
        },

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();

            if (this.deleteAt == 'special-table') {
                this.special_table = this.special_table.filter((val) => val !== this.specialDelete);
                this.displayConfirmation = false;
                this.imp_special = this.special_table;
            } else if (this.deleteAt == 'disaster-table') {
                this.disaster_table = this.disaster_table.filter((val) => val !== this.disasterDelete);
                this.displayConfirmation = false;
                this.imp_disaster = this.disaster_table;
            } else if (this.deleteAt == 'history-table') {
                this.history_table = this.history_table.filter((val) => val !== this.historyDelete);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else {
                await this.axios
                    .post(`${this.$url_service}/initial/officer?user=${userId}`, {
                        body: {
                            topic: 'delete-officer',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchManInfo()
                    );
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลกำลังคน",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลกำลังคน',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        showImage(data) {
            const resolved = this.resolveImageSrc(data);
            if (!resolved) {
                this.imgTable = null;
            } else {
                this.imgTable = [resolved];
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];

            if (
                this.imp_prefix_name == null ||
                this.imp_firstname == '' ||
                this.imp_lastname == '' ||
                this.imp_organize.name == undefined ||
                this.imp_start_workDate == '' ||
                this.contact_phone == '' ||
                this.contact_phone_office == ''
            ) {
                if (this.imp_prefix_name == null) {
                    this.error_imp_prefix_name = true;
                }
                if (this.imp_firstname == '') {
                    this.error_imp_firstname = true;
                }
                if (this.imp_lastname == '') {
                    this.error_imp_lastname = true;
                }
                if (this.imp_organize.name == undefined) {
                    this.error_imp_organize = true;
                }
                if (this.imp_start_workDate == '') {
                    this.error_imp_start_workDate = true;
                }

                if (this.contact_phone == '') {
                    this.error_contact_phone = true;
                }

                if (this.contact_phone_office == '') {
                    this.error_contact_phone_office = true;
                }
            } else {
                var check;
                if (this.imp_email != '') {
                    var re =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    check = re.test(this.imp_email);
                    // console.log("Email validate : " + check);
                }

                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (check == false) {
                    this.error_email_format = true;
                } else {
                    if (!this.error_contact_phone && !this.error_contact_phone_office) {
                        if (this.selectedData == '') {
                            const workdate_n = new Date(this.imp_start_workDate);
                            const ye_n = new Intl.DateTimeFormat('en', {
                                year: 'numeric'
                            }).format(workdate_n);
                            const mo_n = new Intl.DateTimeFormat('en', {
                                month: '2-digit'
                            }).format(workdate_n);
                            const da_n = new Intl.DateTimeFormat('en', {
                                day: '2-digit'
                            }).format(workdate_n);
                            var new_date = `${ye_n}-${mo_n}-${da_n}`;

                            // โหลดเพิ่มแก้ไข 4/8
                            this.loadingCreate = true;
                            // โหลดเพิ่มแก้ไข 4/8 จบ

                            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                            const userId = this.getUsername();

                            await this.axios
                                .post(`${this.$url_service}/initial/officer?user=${userId}`, {
                                    body: {
                                        officer_id: 'off-' + Date.now(),
                                        topic: 'add-officer',
                                        userOrg,
                                        prefix: this.imp_prefix_name.system_id,
                                        firstname: this.imp_firstname,
                                        lastname: this.imp_lastname,
                                        organize: this.imp_organize.id,
                                        image: this.$refs.imp_image.innerText,
                                        level_officer: this.imp_level,
                                        position: this.imp_position,
                                        work_date: new_date,
                                        phone: this.imp_phone_number,
                                        mobile_phone: this.imp_mobile_phone_number,
                                        tel_detail: this.iev_phone,
                                        fax: this.imp_fax,
                                        email: this.imp_email,
                                        radio_signal: this.imp_radio_signal,
                                        response_signal: this.imp_response_signal,
                                        secretary_name: this.imp_secretary_name,
                                        secretary_phone: this.imp_secretary_phone,
                                        check_update: this.imp_update_info,
                                        update_date: this.imp_update_info_date_save,
                                        detail: this.imp_detail,
                                        special_table: this.special_table,
                                        disaster_table: this.disaster_table,
                                        history_table: this.history_table,
                                        editor: userId
                                    }
                                })
                                .then((response) => {
                                    (this.check_duplicate = response.data.message),
                                        // this.initialData();
                                        this.searchManInfo();

                                    // โหลดเพิ่มแก้ไข 5/8
                                    this.loadingCreate = false;
                                    // โหลดเพิ่มแก้ไข 5/8 จบ

                                    // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                                    // console.log("this.check_duplicate ",this.check_duplicate)
                                    if (this.check_duplicate == 'duplicate') {
                                        this.imp_organize = {};
                                        this.imp_start_workDate = '';
                                        this.$fire({
                                            type: 'error',
                                            title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                            text: 'มีข้อมูลนี้ในระบบแล้ว',
                                            timer: 3000,
                                            confirmButtonColor: '#d33'
                                        });
                                    } else {
                                        this.imp_organize = {};
                                        this.imp_start_workDate = '';
                                        this.$fire({
                                            title: 'เพิ่มข้อมูลสำเร็จ',
                                            text: 'ข้อมูลกำลังคน',
                                            type: 'success',
                                            timer: 3000,
                                            confirmButtonColor: '#28B463'
                                        });
                                    }
                                });
                            // console.log("Save data");
                            this.tempFor_displayConfirmationCloseModal = 'add';
                            this.manInfoModal = false;
                        } else {
                            var edit_date;

                            if (this.imp_start_workDate != this.selectedData.startwork) {
                                // const date = this.formatDateString_RESET(this.imp_start_workDate)
                                // const workdate_1 = new Date(date);
                                const workdate_1 = new Date(this.imp_start_workDate);
                                const ye_1 = new Intl.DateTimeFormat('en', {
                                    year: 'numeric'
                                }).format(workdate_1);
                                const mo_1 = new Intl.DateTimeFormat('en', {
                                    month: '2-digit'
                                }).format(workdate_1);
                                const da_1 = new Intl.DateTimeFormat('en', {
                                    day: '2-digit'
                                }).format(workdate_1);
                                edit_date = `${ye_1}-${mo_1}-${da_1}`;
                            } else {
                                const workdate_2 = this.selectedData.startwork.split('/');
                                const ye_2 = workdate_2[2];
                                const mo_2 = workdate_2[1];
                                const da_2 = workdate_2[0];
                                edit_date = `${ye_2}-${mo_2}-${da_2}`;
                            }

                            const lastest = new Date();
                            const yel = new Intl.DateTimeFormat('en', {
                                year: 'numeric'
                            }).format(lastest);
                            const mol = new Intl.DateTimeFormat('en', {
                                month: '2-digit'
                            }).format(lastest);
                            const dal = new Intl.DateTimeFormat('en', {
                                day: '2-digit'
                            }).format(lastest);
                            this.imp_update_info_date_save = `${yel}-${mol}-${dal}`;

                            if (this.$refs.imp_image.innerText == '') {
                                this.$refs.imp_image.innerText = this.url;
                            } else {
                                this.$refs.imp_image.innerText = this.$refs.imp_image.innerText;
                            }

                            // โหลดเพิ่มแก้ไข 6/8 จบ
                            this.loadingCreate = true;
                            // โหลดเพิ่มแก้ไข 6/8 จบ

                            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                            const userId = this.getUsername();

                            await this.axios
                                .post(`${this.$url_service}/initial/officer?user=${userId}`, {
                                    body: {
                                        topic: 'edit-officer',
                                        id: this.temp,
                                        prefix: this.imp_prefix_name.system_id,
                                        firstname: this.imp_firstname,
                                        lastname: this.imp_lastname,
                                        organize: this.imp_organize.id,
                                        image: this.$refs.imp_image.innerText,
                                        level_officer: this.imp_level,
                                        position: this.imp_position,
                                        work_date: edit_date,
                                        phone: this.imp_phone_number,
                                        mobile_phone: this.imp_mobile_phone_number,
                                        tel_detail: this.iev_phone,
                                        fax: this.imp_fax,
                                        email: this.imp_email,
                                        radio_signal: this.imp_radio_signal,
                                        response_signal: this.imp_response_signal,
                                        secretary_name: this.imp_secretary_name,
                                        secretary_phone: this.imp_secretary_phone,
                                        check_update: this.imp_update_info,
                                        update_date: this.imp_update_info_date_save,
                                        detail: this.imp_detail,
                                        special_table: this.special_table,
                                        disaster_table: this.disaster_table,
                                        history_table: this.history_table,
                                        editor: userId
                                    }
                                })
                                .then(() =>
                                    // this.initialData()
                                    this.searchManInfo()
                                );

                            // โหลดเพิ่มแก้ไข 7/8 จบ
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 7/8 จบ

                            // this.$toast.add({
                            //   severity: "success",
                            //   summary: "แก้ไขข้อมูลสำเร็จ",
                            //   detail: "ข้อมูลกำลังคน",
                            //   life: 3000,
                            // });
                            this.$fire({
                                type: 'success',
                                title: 'แก้ไขข้อมูลสำเร็จ',
                                text: 'ข้อมูลกำลังคน',
                                timer: 3000,
                                confirmButtonColor: '#28B463'
                            });
                            this.manInfoModal = false;
                        }
                    }
                }
            }
        },

        formatDateTH(time) {
            let dateNew;
            for (let i = 0; i < time.length; i++) {
                const element = time.split('/');
                dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
            }
            return moment(dateNew).locale('th').add(543, 'year').format('DD/MM/YYYY');
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    const [day, month, year] = dateString.split('/');

                    const date = new Date(year, month - 1, day);

                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('imp_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/officer`, {
                    body: {
                        topic: 'showone-officer',
                        id: data
                    }
                })
                .then((response) => {
                    // console.log(response.data.data),
                    (this.selectedData = response.data.data),
                        (this.imp_prefix_name = {
                            system_id: response.data.data.officer_prefix,
                            system_name: response.data.data.prefix_name
                        }),
                        (this.imp_firstname = response.data.data.officer_firstname),
                        (this.imp_lastname = response.data.data.officer_lastname),
                        (this.imp_organize = {
                            id: response.data.data.officer_organize,
                            name: response.data.data.organize_name
                        }),
                        (this.url = this.pickRecordImageRaw(response.data.data, 'officer_image')),
                        (this.imp_position = response.data.data.officer_position),
                        (this.imp_start_workDate = response.data.data.startwork),
                        (this.imp_phone_number = response.data.data.officer_phone),
                        (this.imp_mobile_phone_number = response.data.data.officer_mobile_phone),
                        (this.imp_fax = response.data.data.officer_fax),
                        (this.imp_email = response.data.data.officer_email),
                        (this.imp_radio_signal = response.data.data.officer_radio_signal),
                        (this.imp_response_signal = response.data.data.officer_response_signal),
                        (this.imp_secretary_name = response.data.data.secretary_name),
                        (this.imp_secretary_phone = response.data.data.secretary_phone),
                        (this.iev_phone = JSON.parse(response.data.data.tel_detail));
                    // if (this.iev_phone != null) {
                    for (let index = 0; index < this.iev_phone.length; index++) {
                        const element = this.iev_phone[index];
                        this.contact_phone = element.phone;
                        this.contact_phone_office = element.tel;
                        this.contact_phone_office_ext = element.tel_ext;
                        // console.log("element.tel",element.tel)
                    }
                    // }
                    // (this.imp_update_info_date = response.data.data.update_date),
                    const date = response.data.data.update_date;
                    (this.imp_update_info_date = this.formatDateTH(date)),
                        (this.imp_detail = response.data.data.officer_detail),
                        (this.imp_update_info = [response.data.data.update_info]),
                        (this.special_table = JSON.parse(response.data.data.specialist_id)),
                        (this.imp_special = JSON.parse(response.data.data.specialist_id)),
                        (this.disaster_table = JSON.parse(response.data.data.disaster_id)),
                        (this.imp_disaster = JSON.parse(response.data.data.disaster_id)),
                        (this.history_table = JSON.parse(response.data.data.training_history_table));

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('imp_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.manInfoModal = false;
                this.selectedData = '';
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            (this.imp_prefix_name = null), (this.imp_firstname = '');
            this.imp_lastname = '';
            this.url = null;
            document.getElementById('imp_uploadImageFile').value = '';
            this.imp_organize = {};
            this.imp_start_workDate = '';
            this.imp_update_info = '';
            this.imp_position = '';
            this.imp_phone_number = '';
            this.imp_mobile_phone_number = '';
            this.imp_fax = '';
            this.imp_email = '';
            this.imp_radio_signal = '';
            this.imp_response_signal = '';
            this.imp_secretary_name = '';
            this.imp_secretary_phone = '';
            this.imp_detail = '';
            this.imp_level = null;
            this.imp_course_name = null;
            this.imp_disaster = null;
            this.disaster_table = [];
            this.imp_special = null;
            this.special_table = [];
            this.history_table = [];
            this.error_imp_prefix_name = false;
            this.error_imp_firstname = false;
            this.error_imp_lastname = false;
            this.error_imp_organize = false;
            this.error_imp_start_workDate = false;
            this.error_email_format = false;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.fullname = '';
            this.selectedOrganize = {};
            this.levelSelected = null;
            this.imp_start_workDate = '';
            this.disasterTypeSelected = null;
            this.courseLevelSelected = null;
            this.courseSelected = null;
            this.searchby = '';
            this.check_update_info = [];

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.organize_table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.fullname = '';
                this.selectedOrganize = {};
                this.levelSelected = null;
                this.imp_start_workDate = '';
                this.disasterTypeSelected = null;
                this.courseLevelSelected = null;
                this.courseSelected = null;
                this.searchby = '';
                this.check_update_info = [];

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log("deleteAt",deleteAt)
                    // console.log("temp",temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 130;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 7) {
                this.PDF_minCellWidthVer = 80;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },
                    date_update_ddmmyy: { cellWidth: 80 },
                    text_tel_detail: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 9) {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    officer_fullname: { cellWidth: 55 },
                    level_name: { cellWidth: 45 },
                    // organize_name:{cellWidth:60},
                    specialist_id: { cellWidth: 40 },
                    officer_response_signal: { cellWidth: 45 },

                    text_tel_detail: { cellWidth: 60 },

                    user_fullname: { cellWidth: 45 },
                    date_update_ddmmyy: { cellWidth: 65 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },

                    level_name: { cellWidth: 50 },
                    organize_name: { cellWidth: 75 },
                    specialist_id: { cellWidth: 70 },
                    officer_response_signal: { cellWidth: 55 },

                    text_tel_detail: { cellWidth: 60 },

                    user_fullname: { cellWidth: 50 }
                };
            } else {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 9;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_officer_fullname = false;
                this.columns_officer_position_name = false;
                this.columns_level_name = false;
                this.columns_organize_name = false;
                this.columns_specialist_id = false;
                this.columns_officer_response_signal = false;
                this.columns_officer_mobile_phone = false;
                // this.columns_update_date = false
                this.columns_user_fullname = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'officer_image') {
                        this.columns_img = true;
                    } else if (!getData.includes('officer_image')) {
                        this.columns_img = false;
                    }

                    if (element == 'officer_fullname') {
                        this.columns_officer_fullname = true;
                    } else if (!getData.includes('officer_fullname')) {
                        this.columns_officer_fullname = false;
                    }

                    if (element == 'officer_position_name') {
                        this.columns_officer_position_name = true;
                    } else if (!getData.includes('officer_position_name')) {
                        this.columns_officer_position_name = false;
                    }

                    if (element == 'level_name') {
                        this.columns_level_name = true;
                    } else if (!getData.includes('level_name')) {
                        this.columns_level_name = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'specialist_id') {
                        this.columns_specialist_id = true;
                    } else if (!getData.includes('specialist_id')) {
                        this.columns_specialist_id = false;
                    }

                    if (element == 'officer_response_signal') {
                        this.columns_officer_response_signal = true;
                    } else if (!getData.includes('officer_response_signal')) {
                        this.columns_officer_response_signal = false;
                    }

                    // if (element == "officer_mobile_phone") {
                    //   this.columns_officer_mobile_phone = true
                    // }else if(!getData.includes("officer_mobile_phone")){

                    //   this.columns_officer_mobile_phone = false
                    // }

                    if (element == 'text_tel_detail') {
                        this.columns_officer_mobile_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_officer_mobile_phone = false;
                    }

                    // if (element == "update_date") {
                    //   this.columns_update_date = true
                    // }else if(!getData.includes("update_date")){

                    //   this.columns_update_date = false
                    // }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}

.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
        #Create{
        width: 146px;
      }
     
  } */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }

    .MP_courseOptions {
        width: 15.1rem;
        overflow-y: scroll;
    }
    .MP_courseOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .MP_courseOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .MP_courseOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
/* Doe UI Dropdown */
@media screen and (max-width: 430px) {
    .MP_course_name {
        width: 17.125rem;
        overflow-y: scroll;
    }
    .MP_course_name::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .MP_course_name::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    .MP_course_name::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    width: 234px;
    border: solid 1px #cccccc;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
// :deep(.p-dropdown) {
//     .p-dropdown-label{

//     font-family: "Sarabun","Helvetica", sans-serif ;
//   }

// }
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
